// extracted by mini-css-extract-plugin
export default {"root":"VerticalDivider_root__0XwVE","divider":"VerticalDivider_divider__mYWMZ"};